// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaTikTok_root__7eW51"};